import { State } from '../apps/appCreator/store';

export default function(state: State) {
  return state.book;
}
